"use strict";
require('../../layouts/web');

$(document).ready(function() {
    $('.post').owlCarousel({
        loop: false,
        margin: 20,
        items: 1,
        dots: false,
        autoplay: false,
        nav: true,
        navText: ["<i class='fa-solid fa-arrow-left'></i>", "<i class='fa-solid fa-arrow-right'></i>"],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            800: {
                items: 2,
            },
            1000: {
                items: 3,
            }


        }

    })
})
var IpixCareers = function() {

    var initCarousels = function() {

        IpixJson.options.owlcarousel.responsive = { 0: { items: 1, dots: true }, 390: { items: 2, dots: true }, 768: { items: 3, } };
        IpixJson.options.owlcarousel.autoplayTimeout = 3000;
        IpixJson.options.owlcarousel.loop = false;
        IpixJson.options.owlcarousel.margin = 20;
        IpixJson.options.owlcarousel.items = 1;
        IpixJson.options.owlcarousel.dots = false;
        IpixJson.options.owlcarousel.autoplay = false;
        IpixJson.options.owlcarousel.nav = false;
        IpixJson.options.owlcarousel.responsiveClass = true;
        $('.career-recent-post').owlCarousel(IpixJson.options.owlcarousel);

        // IpixJson.options.owlcarousel.responsive = { 0: { items: 1, }, 600: { items: 3, }, 800: { items: 4, }, 1000: { items: 5, }, 1300: { items: 6, } };
        // IpixJson.options.owlcarousel.items = 5.2;
        // IpixJson.options.owlcarousel.margin = 5;
        // $('.colleagues').owlCarousel(IpixJson.options.owlcarousel);
    }

    return {
        init: function() {
            initCarousels();
        }
    }
}();

// On document ready
IpixUtil.onDOMContentLoaded(function() {
    IpixCareers.init();
});
